// "Fri Oct 27 2023 00:00:00 GMT-0300 (Brasilia Standard Time)" e transforma nessa formatacao : 2023-10-18
export default function FormatarDataLonga(dataString: string) {
  const dataOriginal = new Date(dataString);
  const ano = dataOriginal.getFullYear();
  const mes = String(dataOriginal.getMonth() + 1).padStart(2, "0");
  const dia = String(dataOriginal.getDate()).padStart(2, "0");

  return `${ano}-${mes}-${dia}`;
}
